import React from 'react';
import Modal from 'react-modal';
import SearchResultsComp from './search-results';
import GlobalSearchFiltersComp from './search-filters';
import SerachServices from '../../services/search.services';
import SearchTagComp from './search-tag';
import {ShowHidePageScroll} from '../../utils/function';
import {WbUniqueIdMixin} from '../../utils/common';
import SearchUtils from './search-util';
import qs from 'qs';
import axios from 'axios';
import { withTranslation } from 'react-i18next';

var CancelToken = axios.CancelToken;
export default withTranslation()(class GlobalSearchComp extends React.Component {
    constructor(props) {
        super(props);
        Modal.setAppElement('#page');

        let initStates = this.initStates();
        initStates.screenHeight = document.documentElement.clientHeight;
        if (typeof this.props.filter !== 'undefined' && this.props.filter !== null 
            && Object.keys(this.props.filter).length) {
            let _filter = this.props.filter;
            let {hmt=0, hoc = 0, hac = 0, type = 0, ai_owner=[], 
                rbr_owner=[], okr_owner=[], kr_owner=[], okr_category=[],
                ai_ws = [], kpi_owner=[],
                meet_tag=0, time = 0
            } = _filter.filter;
            let isAppliedSubFilters = (rbr_owner.length || okr_owner.length || kr_owner.length 
                || time > 0 || meet_tag > 0 || okr_category.length || ai_owner.length || ai_ws.length || kpi_owner.length);
            if ((hmt == 1 || hoc == 1 || hac == 1) 
                || (type > 0 && isAppliedSubFilters)) {
                initStates.showAdvancedOption = true;
            }
            if (typeof _filter.tab !== 'undefined' && _filter.tab !== null) {
                initStates.tab = _filter.tab;
                initStates.tags = _filter.tags || [];
            }
            initStates.searchText = _filter.searchText;
            initStates.filter = {...initStates.filter, ..._filter.filter};
        }
        this.state = {...initStates, isOpen: true};

        this.defaultCustomPeriodDates = this.defaultCustomPeriodDates.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.clickTab = this.clickTab.bind(this);
        this.onAfterOpenModal = this.onAfterOpenModal.bind(this);
        this.onChangeSearchText = this.onChangeSearchText.bind(this);
        this.onClickRecentSearch = this.onClickRecentSearch.bind(this);
        this.onChangeType = this.onChangeType.bind(this);
        this.showAdvancedFilters = this.showAdvancedFilters.bind(this);
        this.onChangeCheckbox = this.onChangeCheckbox.bind(this);
        this.onClickOwner = this.onClickOwner.bind(this);
        this.removeOwner = this.removeOwner.bind(this);
        this.onChangeDateFilters = this.onChangeDateFilters.bind(this);
        this.updateFilters = this.updateFilters.bind(this);
        this.onChangeMeetTag = this.onChangeMeetTag.bind(this);
        this.loadMoreSearchResults = this.loadMoreSearchResults.bind(this);
        this.callSearch = this.callSearch.bind(this);
        this.showListOfResults = this.showListOfResults.bind(this);
        this.setResultContainerHeight = this.setResultContainerHeight.bind(this);
        this.searchServices = new SerachServices();
        //this.delayedCalleback = _.debounce(this.callSearch, 300);
        this.searchInputText = React.createRef();
        this.searchResultKey = this.setSearchResultKey();
        this.cancelRequest = null;
        this.clearSearchResults = this.clearSearchResults.bind(this);
        this.updateDimensions = this.updateDimensions.bind(this);
        this.handleResize = _.debounce(this.updateDimensions, 300);
        this.generateSearchEvent = this.generateSearchEvent.bind(this);

        // push a analytics event if search pop-up is opened from global search icon
        if (!(window.location.pathname || '').endsWith('searchResults')) {
            SearchUtils.pushGlobalSearchEvent('GLOBAL_SEARCH_OPENED');
        }
    }

    setSearchResultKey() {
        return WbUniqueIdMixin.randomId('search-results-');
    }

    componentDidMount() {
        ShowHidePageScroll();
        setTimeout(() => {
            if (this.searchInputText.current) {
                this.searchInputText.current.focus();
            }
        }, 0);
        if (typeof this.props.filter !== 'undefined' && this.props.filter !== null) {
            this.callSearch();
        }
        window.addEventListener("resize", this.handleResize.bind(this));
    }

    componentWillUnmount() {
        window.addEventListener("resize", this.handleResize.bind(this));
    }

    updateDimensions() {
       this.setState({screenHeight: document.documentElement.clientHeight}, () => {
            this.setResultContainerHeight();
       });
    }

    initStates() {
        const customPeriod = this.defaultCustomPeriodDates();
        return {
            isOpen: false,
            tab: 1,
            tags: [],
            searchText: '',
            total: 0,
            results: [],
            recent_searches: [],
            icon_loading: false,
            showAdvancedOption: false,
            filter: {
                type: '',
                rbr_owner: [],
                ai_owner: [],
                okr_owner: [],
                kr_owner: [],
                okr_category: [],
                ai_ws: [],
                kpi_owner: [],
                time: 0,
                start_date: customPeriod.start_date,
                end_date: customPeriod.end_date,
                meet_tag: 0,
                hmt: 0,
                hoc: 0,
                hac: 0,
                hakpi: 0
            },
            searchCount: 0
        };
    }

    openModal() {
        this.setState({isOpen: true}, () => {
            ShowHidePageScroll();
        });
    }

    defaultCustomPeriodDates() {
        const filterOptions = this.props.filterOptions;
        let customPeriod = filterOptions.filter(t => t.value == 5);
        if (customPeriod.length) {
            customPeriod = customPeriod[0];
        }
        return {
            start_date: customPeriod.start,
            end_date: customPeriod.end
        };
    }

    closeModal() {
        this.setState(this.initStates(), () => {
            ShowHidePageScroll(true);
        });
        SearchUtils.pushGlobalSearchEvent('GLOBAL_SEARCH_RESULTS_CANCELED');
    }

    getParent() {
        return document.getElementById('page');
    }

    clickTab(tab) {
        this.setState({tab, tags: []}, () => {
            if (tab == 1 && this.searchInputText.current !== null) {
                this.searchInputText.current.focus();
            }
        });
    }

    loadMoreSearchResults() {
        this.callSearch({pagination: true});
    }

    buildParams() {
        let query = {};
        const filter = this.state.filter;
        const filterType = filter.type;
        if (filterType) {
            query.type = filterType;
            let time = filter.time;
            if (filterType == '1') {
                let aiOwner = filter.ai_owner;
                let ws_id = filter.ai_ws;
                if (aiOwner.length) {
                    query.owner = aiOwner[0]['userId'];
                }
                if (ws_id.length) {
                    query.ws_id = ws_id[0]['id'];
                }
            }
            else if (filterType == '2') {
                let okrOwner = filter.okr_owner;
                let krOwner = filter.kr_owner;
                let okrCat = filter.okr_category;
                if (okrOwner.length) {
                    query.okr_owner = okrOwner[0]['userId'];
                }
                if (krOwner.length) {
                    query.kr_owner = krOwner[0]['userId'];
                }
                if (okrCat.length) {
                    query.okr_cat = okrCat[0]['id'];
                }
            }
            else if (filterType == '3') {
                let meetTag = filter.meet_tag;
                if (meetTag > 0) {
                    query.meet_tag = meetTag;
                }
            }
            else if (filterType == '4') {
                let rbrOwner = filter.rbr_owner;
                if (rbrOwner.length) {
                    query.rbr_owner = rbrOwner[0]['_id'];
                }
            }
            else if (filterType == '8') {
                let kpiOwner = filter.kpi_owner;
                if (kpiOwner.length) {
                    query.kpi_owner = kpiOwner[0]['_id'];
                }
                if (filter.hakpi) {
                    query.hakpi = filter.hakpi;
                }
            }
            if (time > 0) {
                if (time != 5) {
                    let findTime = this.props.filterOptions.find(t => t.value == time);
                    if (findTime) {
                        query.start = findTime.start;
                        query.end = findTime.end;
                    }
                }
                else {
                    query.start = filter.start_date;
                    query.end = filter.end_date;
                }
            }
        }

        if (typeof filter.hac !== 'undefined' && filter.hac == '1') {
            query.hac = 1;
        }
        if (typeof filter.hoc !== 'undefined' && filter.hoc == '1') {
            query.hoc = 1;
        }
        if (typeof filter.hmt !== 'undefined' && filter.hmt == '1') {
            query.hmt = 1;
        }
        if (typeof filter.hakpi !== 'undefined' && filter.hakpi == '1') {
            query.hakpi = 1;
        }
        let hstatus = [];
        if (typeof filter.hopen !== 'undefined' && filter.hopen == '1') {
            hstatus.push(1);
        }
        if (typeof filter.hclosed !== 'undefined' && filter.hclosed == '1') {
            hstatus.push(2);
        }
        if (hstatus.length) {
            query.hstatus = hstatus.join(',');
        }

        return query;
    }

    callSearch(params = {}) {
        let _this = this;
        let {searchText='', results = [], total = 0, filter = {}} = this.state;
        let {ai_owner=[], ai_ws=[], rbr_owner=[], okr_owner=[], kr_owner=[], okr_category=[], kpi_owner=[]} = filter;
        let isSubFiltersApplied = (ai_owner.length || ai_ws.length || rbr_owner.length || okr_owner.length || kr_owner.length || okr_category.length || kpi_owner.length);
        let processRequest = (searchText || isSubFiltersApplied);
        if (processRequest) {
            let query = params;
            query.q = searchText;
            let isPagination = false;
            if (typeof query.pagination !== 'undefined' && query.pagination == true) {
                isPagination = true;
                const pageLimit = 200;
                const currentItems = results.length;
                const totalPage = Math.ceil(total / pageLimit);
                let currentPage = Math.ceil(currentItems / pageLimit);
                if (currentPage == totalPage) {
                    return;
                }
                if (totalPage > 1 && currentPage < totalPage) {
                    query.page = currentPage++;
                }
            }
            else {
                this.searchResultKey = this.setSearchResultKey();
            }
            query = {...query, ...this.buildParams()};

            if (_this.cancelRequest != null) {
                _this.cancelRequest();
            }

            axios({
                method: 'get',
                headers: {'X-Requested-With': 'XMLHttpRequest'},
                url: wbConfig.baseUrl + '/search/globalSearch',
                cancelToken: new CancelToken(function executor(c) {
                    _this.cancelRequest = c;
                }),
                params: query
            })
            .then(response => {
                if (response.data) {
                    const data = response.data.data;
                    let _result = (typeof data.results !== 'undefined') ? data.results : [];
                    data.total = _result.length;
                    results = isPagination ? results.concat(..._result) : _result;
                    data.total = results.length;
                    let total = (typeof data.total !== 'undefined') ? data.total : 0;
                    _this.setState({
                        results: results,
                        total: total,
                        icon_loading: false
                    }, () => {
                        _this.setResultContainerHeight();
                    });
                }
            });

            this.state.searchCount++;
            this.generateSearchEvent();
        }
        else {
           this.clearSearchResults();
        }
    }

    clearSearchResults() {
        if (this.cancelRequest != null) {
            this.cancelRequest();
        }
        this.setState({
            total: 0,
            results: [],
            icon_loading: false
        });
    }

    setResultContainerHeight() {
        let scrollbox = document.querySelector('.search-result-table-wrapper');
        if (scrollbox) {
            const windowInnerHeight = window.innerHeight;
            scrollbox.style.minHeight = `${windowInnerHeight - 290}px`;
            scrollbox.style.maxHeight = `${windowInnerHeight - 290}px`;
        }
    }

    showListOfResults() {
        let {searchText} = this.state;
        let query = this.buildParams();
        if (searchText) {
            query.q = searchText;
        }
        let url = wbConfig.baseUrl + '/search/searchResults';
        //q=test;;type__1;;ws__1257
        //q=test;;type__1;;uid__235;;bt__10/01/2019%20-%2010/31/2019&_=1571897833511
        //q=test;;type__2;;uid__235;;st__1;;bt__10/01/2019%20-%2010/31/2019;;st__2
        //q=tes;;type__3;;uid__235;;st__1;;bt__10/01/2019%20-%2010/31/2019
        SearchUtils.pushGlobalSearchEvent('GLOBAL_SEARCH_MORE_RESULTS_USED', { source: window.location.pathname });

        window.location.href = url + '?' + qs.stringify(query, { arrayFormat: 'brackets' });
    }

    onChangeSearchText(e) {
        e.persist();

        if (!this.debouncedOnChangeSearchText) {
          this.debouncedOnChangeSearchText =  _.debounce(() => {
              let val = e.target.value.trim();
              this.setState({
                  icon_loading: true,
                  searchText: val
              },
              () => {
                  this.callSearch();
              });
         }, 800);
        }
        this.debouncedOnChangeSearchText();
    }

    onAfterOpenModal() {
    }

    onClickRecentSearch(text) {
    }

    updateFilters(filter = {}) {
        if (Object.keys(filter).length) {
            this.setState({
                filter: {
                    ...this.state.filter,
                    ...filter
                }
            },() => {
                this.callSearch();
            });
        }
    }

    onChangeMeetTag(e, item) {
        this.setState({
            filter: {...this.state.filter, meet_tag: item.value}
        }, () => {
            this.callSearch();
        });
    }
    
    onClickOwner(owner, field, searchboxInst) {
        this.setState({
            filter: {...this.state.filter, [field]: [owner]}
        }, () => {
            if (searchboxInst) {
                searchboxInst.closeBox();
            }
            this.callSearch();
        });
    }

    removeOwner(owner, field) {
        let filterValue = [];
        if (field == 'okr_category') {
            filterValue = this.state.filter[field].filter(v => v.id != owner.id);
        }
        else if (field == 'ai_owner' || field == 'okr_owner' || field == 'kr_owner') {
            filterValue = this.state.filter[field].filter(v => v.userId != owner.userId);
        }
        else if (field == 'ai_ws') {
            filterValue = this.state.filter[field].filter(v => v.id != owner.id);
        }
        else {
            filterValue = this.state.filter[field].filter(v => v._source.id != owner._source.id);
        }
        this.setState({
            filter: {...this.state.filter, [field]: filterValue}
        }, () => {
            this.callSearch();
        });
    }

    onChangeType(event) {
        let checkedValue = event.target.value;
        let filter = this.initStates().filter;
        if (!event.target.checked) {
            checkedValue = '';
        }
        filter.type = checkedValue;
        this.setState({
            filter,
            showAdvancedOption: false
        }, () => {
            let moreOptionWrapper = document.querySelector('.more-options-wrapper');
            if (moreOptionWrapper) {
                const windowInnerHeight = window.innerHeight - 300;
                if (filter.type == '2') {
                    moreOptionWrapper.style.minHeight = `${windowInnerHeight}px`;
                    moreOptionWrapper.style.maxHeight = `${windowInnerHeight}px`;
                    moreOptionWrapper.style.overflow = 'auto';
                }
                else {
                    moreOptionWrapper.style = {};
                }
            }
            this.callSearch();
        });
    }

    onChangeDateFilters(e, item) {
        this.setState({
            filter: {
                ...this.state.filter,
                time: item.value
            },
        }, () => {
            this.callSearch();
        });
    }

    emptyResults() {
        const { t } = this.props
        const {searchText = '', filter = {}} = this.state;
        let isFilterApplied = false;
        let {ai_owner=[], ai_ws=[], rbr_owner=[], okr_owner=[], kr_owner=[], okr_category=[]} = filter;
        let isSubFiltersApplied = (ai_owner.length || ai_ws.length || rbr_owner.length || okr_owner.length || kr_owner.length || okr_category.length);
        if (searchText || isSubFiltersApplied) {
            isFilterApplied = true;
        }
        const emptyStyle = {
            textAlign: (isFilterApplied) ? 'left' : 'center'
        };
        return (
            <div className="empty-results-wrapper" style={emptyStyle}>
                {
                    isFilterApplied ?
                    <div className="no-search-results-wrapper">
                        {!this.state.icon_loading?
                        <>
                            <div className="no-search-results">{t('No search results')}</div>
                            <div className="no-search-results-try">
                                <span>{t('You may want to try')}:</span>
                                <ul>
                                    <li>{t('Using different keywords')}</li>
                                    <li>{t('Checking for typos')}</li>
                                    <li>{t('Adjusting your filters')}</li>
                                </ul>
                            </div>
                        </>
                        :""}
                    </div>
                :
                <div>
                    <div className="search-results-will">
                        {t('Search results will appear here')}
                    </div>
                    <div className="empty-results-image">
                        <img width="250" src={`${wbConfig.baseUrl}/images/global_search/artboard-2-3-x@3x.png`} />
                    </div>
                </div>
                }
            </div>
        );
    }

    renderRecentSearches() {
        const { t } = this.props
        const recent_searches = this.state.recent_searches || [];
        return (
            <div className="recent-searches-wrapper">
                <div className="recent-searches-title">
                    {t('Recent searches')}
                </div>
                <div className="recent-searches-items-wrapper">
                    {
                        recent_searches.map((search, index) => (
                            <div key={index} className="recent-searches-item" onClick={() => this.onClickRecentSearch(search)}>
                                <i className="icon icon-outline-search-18px"></i>
                                <span>{search}</span>
                            </div>
                        ))
                    }
                </div>
            </div>
        )
    }

    renderResults() {
        const { t } = this.props
        const {results=[], recent_searches = [], total} = this.state;
        const resultsLength = Array.isArray(results) ? results.length : 0;
        let krownerFilter = this.state.filter.kr_owner && this.state.filter.kr_owner.length > 0 ? true : false;
        if (!resultsLength) {
            if (recent_searches.length) {
                return this.renderRecentSearches();
            }
            else {
                return this.emptyResults();
            }
        }
        else {
            return (
                <div className=''>
                    <div className="result-count">{total} {t('results')}</div>
                    <SearchResultsComp 
                        key={this.searchResultKey}
                        results={results} 
                        loadMoreSearchResults={this.loadMoreSearchResults}
                        closeModal={this.closeModal}
                        categoryId={this.state.filter.okr_category.length > 0 ? this.state.filter.okr_category[0].id : ""}
                        krownerFilter={krownerFilter}
                     />
                </div>
            )
        }
    }

    onChangeCheckbox(e) {
        const name = e.target.name;
        let value = '';
        if (e.target.checked) {
            value = e.target.value;
        }
        this.setState({
            filter: {...this.state.filter, [name]: value}
        }, () => {
            this.callSearch();
        });
    }

    showAdvancedFilters() {
        this.setState({
            showAdvancedOption: true
        });
    }

    generateSearchEvent() {
        const filter = this.state.filter || {};
        const eventType = (this.state.searchCount > 1)
            ? 'GLOBAL_SEARCH_POP_UP'
            : 'GLOBAL_SEARCH_USED';
        const defaultDate = this.defaultCustomPeriodDates();
        const properties = { tag: 'NO' };

        switch (filter.type) {
            case '1': // Action items and workstreams
                properties.search_filter_used = 'AI_AND_WORKSTREAMS';
                if (filter.hac 
                        || filter.ai_owner.length 
                        || filter.ai_ws.length 
                        || filter.start_date !== defaultDate.start_date 
                        || filter.end_date !== defaultDate.end_date) {
                    properties.advanced_filter_used = 'YES';
                } else {
                    properties.advanced_filter_used = 'NO';
                }
                break;
            case '2': // Objectives and key results
                properties['search_filter_used'] = 'OKR';
                if (filter.hoc 
                        || filter.hopen 
                        || filter.hclosed 
                        || filter.okr_owner.length 
                        || filter.kr_owner.length 
                        || filter.okr_category.length
                        || filter.start_date !== defaultDate.start_date 
                        || filter.end_date !== defaultDate.end_date) {
                    properties.advanced_filter_used = 'YES';
                } else {
                    properties.advanced_filter_used = 'NO';
                }
                break;
            case '3': // Meetings
                properties.search_filter_used = 'MEETINGS';
                if (filter.hmt
                        || filter.meet_tag
                        || filter.start_date !== defaultDate.start_date 
                        || filter.end_date !== defaultDate.end_date) {
                    properties.advanced_filter_used = 'YES';
                } else {
                    properties.advanced_filter_used = 'NO';
                }
                break;
            case '4': // Biz reviews
                properties.search_filter_used = 'RBR';
                properties.advanced_filter_used = (filter.rbr_owner.length) ? 'YES' : 'NO';
                break;
            case '5': // Teams
                properties.search_filter_used = 'TEAMS';
                if (filter.start_date !== defaultDate.start_date 
                        || filter.end_date !== defaultDate.end_date) {
                    properties.advanced_filter_used = 'YES';
                } else {
                    properties.advanced_filter_used = 'NO';
                }
                break;
            case '8': // KPIs
                properties.search_filter_used = 'KPI';
                if (filter.hakpi || filter.kpi_owner.length) {
                    properties.advanced_filter_used = 'YES';
                } else {
                    properties.advanced_filter_used = 'NO';
                }
                break;
            default:
                properties.search_filter_used = '';
                properties.advanced_filter_used = '';
        }

        SearchUtils.pushGlobalSearchEvent(eventType, properties);
    }

    render() {
        const screenHeight = this.state.screenHeight;
        const results = this.state.results || [];
        const searchText = (typeof this.props.filter !== 'undefined' && this.props.filter !== null)
             ? this.props.filter.searchText : '';
        const userPermissions = this.props.userPermissions || {};
        const executeModule = userPermissions.execute || false;
        const resultsLength = Array.isArray(results) ? results.length : 0;
        const { t } = this.props
        return (
            <div className="global-search-wrapper">
                <Modal
                isOpen={this.state.isOpen}
                ariaHideApp={false}
                parentSelector={this.getParent}
                onRequestClose={this.closeModal}
                onAfterOpen={this.onAfterOpenModal}
                className="react-modal-global-search"
                overlayClassName="react-modal-global-search-overlay"
                style={{
                    content: {
                        height: (screenHeight - 100) + 'px',
                        marginTop: '50px'
                    }
                }}
                >
                    <div className="global-search-container">
                        <div className="global-search-header">
                            <div className="header-left">
                                <div data-testid="search" className={"global-search-tab " + (this.state.tab == '1' ? 'active' : '')} onClick={() => this.clickTab(1)}>{t('Search')}</div>
                                {
                                    executeModule
                                    && <div data-testid="search-by-tag" className={"global-search-tab " + (this.state.tab == '2' ? 'active' : '')} onClick={() => this.clickTab(2)}>{t('Search by tag')}</div>
                                }
                            </div>
                            <div className="header-right">
                                <div className="icon icon-outline-close-24px" onClick={() => this.closeModal()}></div>
                            </div>
                            <div className="clear"></div>
                        </div>
                        {
                            this.state.tab == '2' ?
                            <div className='global-search-content'>
                                <SearchTagComp 
                                    currentUserId={this.props.currentUserId} 
                                    tags={this.state.tags}
                                 />
                            </div>
                            :
                            <div className="global-search-content">
                                <div className="global-search-content-left" style={{height: (screenHeight - 140) + 'px'}}>
                                    <div className="global-search-left-content">
                                        <div className="searchbox-input-group">
                                            <i className="icon icon-outline-search-18px"></i>
                                            <input placeholder={t("Search")}
                                            className="searchbox" 
                                            data-testid="globalSearchBox"
                                            tabIndex="0" 
                                            defaultValue={searchText}
                                            ref={this.searchInputText}
                                            onChange={e => this.onChangeSearchText(e)} />
                                            <span className={(this.state.icon_loading ? ' loading-spinner ' : '')}></span>
                                        </div>
                                    </div>
                                    <div className="search-results-wrapper">
                                        { this.renderResults()}
                                    </div>
                                    {
                                        resultsLength ? 
                                            <div className='search-result-link-wrapper'>
                                                <div className='show-list-of-results' onClick={() => this.showListOfResults()}>
                                                    <span dangerouslySetInnerHTML={{__html: `${t('Show list of results')} &gt;`}} />
                                                </div>
                                            </div>
                                        : ''
                                    }
                                </div>
                                <div className="global-search-content-right" style={{height: (screenHeight - 140) + 'px'}}>
                                    <GlobalSearchFiltersComp
                                        state={this.state}
                                        onChangeType={this.onChangeType}
                                        onChangeCheckbox={this.onChangeCheckbox}
                                        showAdvancedFilters={this.showAdvancedFilters}
                                        onClickOwner={this.onClickOwner}
                                        removeOwner={this.removeOwner}
                                        filterOptions={this.props.filterOptions}
                                        onChangeDateFilters={this.onChangeDateFilters}
                                        updateFilters={this.updateFilters}
                                        onChangeMeetTag={this.onChangeMeetTag}
                                        userPermissions={this.props.userPermissions}
                                        enableKpiGlobalSearch={this.props.enableKpiGlobalSearch}
                                    />
                                </div>
                                <div className="clear"></div>
                            </div>
                        }
                    </div>
                </Modal>
            </div>
        );
    }
})
